import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/i18n";
import "@/App.css";

import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Method from "@/pages/Method";
import Portfolio from "@/pages/Portfolio";
import PortfolioDetail from "@/pages/PortfolioDetail";
import About from "@/pages/About";
import Teatro from "@/pages/Teatro";
import Legal from "@/pages/Legal";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import Draw from "@/pages/Draw";
import { PaymentSuccess, PaymentCancel } from "@/pages/Draw";
import StaffLogin from "@/pages/StaffLogin";
import StaffDashboard from "@/pages/StaffDashboard";

function Shell({ children }) {
  return (
    <div className="min-h-screen bg-[#F9F8F6] flex flex-col">
      <Nav />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Shell><Home /></Shell>} />
        <Route path="/servizi" element={<Shell><Services /></Shell>} />
        <Route path="/services" element={<Shell><Services /></Shell>} />
        <Route path="/progettazione-architettonica" element={<Shell><ServiceDetail /></Shell>} />
        <Route path="/spazio-dimostrativo" element={<Shell><ServiceDetail /></Shell>} />
        <Route path="/design-d-interni" element={<Shell><ServiceDetail /></Shell>} />
        <Route path="/consulenza-e-planimetrie" element={<Shell><ServiceDetail /></Shell>} />
        <Route path="/ristrutturazioni" element={<Shell><ServiceDetail /></Shell>} />
        <Route path="/direzione-lavori-e-sicurezza" element={<Shell><ServiceDetail /></Shell>} />
        <Route path="/metodo" element={<Shell><Method /></Shell>} />
        <Route path="/method" element={<Shell><Method /></Shell>} />
        <Route path="/portfolio" element={<Shell><Portfolio /></Shell>} />
        <Route path="/portfolio/:id" element={<Shell><PortfolioDetail /></Shell>} />
        <Route path="/chi-siamo" element={<Shell><About /></Shell>} />
        <Route path="/about" element={<Shell><About /></Shell>} />
        <Route path="/teatro-dinamico" element={<Shell><Teatro /></Shell>} />
        <Route path="/dynamic-theatre" element={<Shell><Teatro /></Shell>} />
        <Route path="/privacy-policy" element={<Shell><Legal /></Shell>} />
        <Route path="/cookie-policy" element={<Shell><Legal /></Shell>} />
        <Route path="/note-legali" element={<Shell><Legal /></Shell>} />
        <Route path="/contatti" element={<Shell><Contact /></Shell>} />
        <Route path="/contact" element={<Shell><Contact /></Shell>} />
        <Route path="/prenota" element={<Shell><Booking /></Shell>} />
        <Route path="/book" element={<Shell><Booking /></Shell>} />
        <Route path="/disegna" element={<Draw />} />
        <Route path="/draw" element={<Draw />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/staff/login" element={<StaffLogin />} />
        <Route path="/staff" element={<StaffDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}
